import { Settings } from '@mui/icons-material';
import { useState } from 'react';
import Button from '../../../core-components/theme/components/Button/Button';
import NotificationSettingsModal from './NotificationSettingsModal';

export const NotificationSetting = () => {
    const [settingsOpen, setSettingsOpen] = useState(false);
    const handleSettingsOpen = () => {
        setSettingsOpen(true);
    };

    const handleSettingsClose = () => {
        setSettingsOpen(false);
    };

    return (
        <>
            <Button startIcon={<Settings />} onClick={handleSettingsOpen} variant="contained">
                Settings
            </Button>
            {settingsOpen && <NotificationSettingsModal open={settingsOpen} onClose={handleSettingsClose} />}
        </>
    );
};

export default NotificationSettingsModal;
